/** Selectors for the create RX flow that are not specific to advanced, manual, or other subflows.
 *
 * TODO - Convert legacy flows to use new script flow actions/selectors, and all this code below gets
 * deleted. The "with CCI" flow uses the script flow module, and there is some inelegant special-casing below
 * for that. But it goes away after everything uses the script flow module.
 *
 * This means updating the manual flow to using script-flow
 */

// constants
import { scriptMethods } from 'constants/scripts';

// selectors
import { getActiveScriptMethod } from 'current/selectors';
import { getStep as getAdvancedStep } from 'advanced/selectors';
import { getStep as getManualStep } from 'manual/selectors';
import { getCurrentPath, isCreateRoute } from 'routes/selectors';
import { 
  getStepTitleTextKey as getStepTitleTextKeyFromScriptFlow, 
  getNumSteps as getScriptFlowNumSteps
} from 'script-flow/selectors';

// TODO - callers call scriptFlow/selectors getStepNumber() instead.
export const getStep = (state) => {
  return (getActiveScriptMethod(state) === scriptMethods.ADVANCED)
    ? getAdvancedStep(state) : getManualStep(state);
};

// TODO - callers call scriptFlow/selectors getNumSteps() instead.
export const getNumSteps = (state) => {
  return getActiveScriptMethod(state) === scriptMethods.ADVANCED ? 3 : getScriptFlowNumSteps(state);
};
// TODO - callers call scriptFlow/selectors getStepTitleTextKey() instead.
export const getStepTitleTextKey = (state) => {
  const isStepZero = isCreateRoute(getCurrentPath(state)); // Is user on first screen for selecting a create script flow?
  if (isStepZero) { return 'title-text__create-script--step-0'; }
  return getStepTitleTextKeyFromScriptFlow(state);
};
